export const CREDENTIAL_DEFAULTS = [
  {
    key: 'registered-ngo',
    title: 'Registered NGO',
    subtitle: 'PPM-001-14-02011979',
    modal_title: 'Registered NGO',
    modal_subtitle: 'PPM-001-14-02011979',
    body: 'The Educational, Welfare and Research Foundation Malaysia is officially registered with the Registrar of Societies (ROS) under the Ministry of Home Affairs, Malaysia.',
    bullets: [],
  },
  {
    key: 'tax-exempt',
    title: 'Tax-Exempt',
    subtitle: 'Section 44(6) Status',
    modal_title: 'Tax-Exempt Status',
    modal_subtitle: 'LHDN Section 44(6)',
    body: 'EWRF holds full tax-exemption status under Section 44(6) of the Income Tax Act 1967, approved by the Inland Revenue Board of Malaysia (LHDN).\n\nThis means every donation you make to EWRF is 100% tax-deductible from your chargeable income when you file your annual tax return in Malaysia. An official receipt is issued for every donation ≥ RM 100.',
    bullets: [],
  },
  {
    key: 'child-safe-policy',
    title: 'Child-Safe Policy',
    subtitle: 'Certified & Audited',
    modal_title: 'Child-Safe Policy',
    modal_subtitle: 'Certified & Audited',
    body: 'EWRF is committed to safeguarding every child, young person and vulnerable adult who comes into contact with our programmes, volunteers or staff.\n\nAll volunteers and facilitators involved in our Language for Juniors (L4J), Civil Society Intervention Plus (CSI+), Counselling and C3G programmes complete mandatory child-safety induction and are bound by our Code of Conduct.',
    bullets: [
      'Background checks on all facilitators before deployment',
      'Two-adult rule enforced at every offline session',
      'Zero-tolerance reporting channel — media@ewrf.org.my',
      'Annual policy review by the Central Committee',
      'Mandatory child-safety induction (VIP programme)',
    ],
  },
  {
    key: 'annual-audits',
    title: 'Annual Audits',
    subtitle: 'Transparent Finances',
    modal_title: 'Annual Audits & Reports',
    modal_subtitle: 'Transparent Finances',
    body: 'EWRF publishes an audited annual report every year, detailing our programmes, impact numbers, financial position and stakeholder acknowledgements. All reports are prepared with an independent external auditor.',
    bullets: [],
  },
];

export const mergeCredentials = (cmsItems) => {
  const byKey = {};
  (cmsItems || []).forEach((it) => { if (it && it.key) byKey[it.key] = it; });
  return CREDENTIAL_DEFAULTS.map((d) => ({ ...d, ...(byKey[d.key] || {}) }));
};
